var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
var cls = classNames('no-results-layout');
export var NoResultsLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: ", ";\n    width: 100%;\n    font-weight: 500;\n    height: 50dvh;\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: ", ";\n    width: 100%;\n    font-weight: 500;\n    height: 50dvh;\n  "])), theme.UNIT(12))
});
var MessageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1.2em;\n  "], ["\n    font-size: 1.2em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Message: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
export var NoResultsLayout = function (props) {
  var className = props.className;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Message, null, t('No Results Found')));
};
NoResultsLayout.cls = cls;
NoResultsLayout.defaultProps = NoResultsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;